import { useEffect, type FC } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import NewConversationView from "./NewConversationView";
import ConversationDetailView from "./ConversationDetailView";
import UpdatesView from "./UpdatesView";
import { useBlocNext } from "@blac/react";
import AppViewCubit from "src/state/AppViewCubit/AppViewCubit";
import ChatDrawerLayout from "./ChatDrawerLayout";

const LAST_CHAT_PATH_KEY = "9am.lastChatPath";

const ChatIndexRedirect: FC = () => {
  const savedPath = sessionStorage.getItem(LAST_CHAT_PATH_KEY);
  if (savedPath && savedPath !== "/app/chat") {
    return <Navigate to={savedPath} replace />;
  }
  return <NewConversationView />;
};

const LeapChatRouter: FC = () => {
  const [, { setAllowIonContentScrollY }] = useBlocNext(AppViewCubit);
  const location = useLocation();

  useEffect(() => {
    setAllowIonContentScrollY(false);
    return () => {
      setAllowIonContentScrollY(true);
    };
  }, [setAllowIonContentScrollY]);

  useEffect(() => {
    if (location.pathname.startsWith("/app/chat/")) {
      sessionStorage.setItem(LAST_CHAT_PATH_KEY, location.pathname);
    }
  }, [location.pathname]);

  return (
    <ChatDrawerLayout>
      <Routes>
        <Route index element={<ChatIndexRedirect />} />
        <Route path="new" element={<NewConversationView />} />
        <Route path="updates" element={<UpdatesView />} />
        <Route path="conversation/:id" element={<ConversationDetailView />} />
        <Route path="*" element={<Navigate to="/app/chat" replace />} />
      </Routes>
    </ChatDrawerLayout>
  );
};

export default LeapChatRouter;
